import React from "react";
import Temp from "./component/weather/temp";

const App = () => {
  return(
    <>
    <Temp/>
    </>
  );

};

export default App;